import React, { useContext, useState, useMemo } from 'react';
import { svgSprite } from '../../wrappers';
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    TelegramShareButton,
    ViberShareButton,
    FacebookIcon,
    TwitterIcon,
    ViberIcon,
    WhatsappIcon,
    TelegramIcon
} from 'react-share';
import uikit from '../../../project/uikit/uikit.module.scss';
import PropTypes from 'prop-types';
import css from './SocialShare.module.scss';
import classnames from 'classnames';
import { t } from '../../../common/components/T';
import UserContext, { UserProfileContext } from '../../../common/utils/getContext';
import { useWidgetTranslates } from '../../../common/utils/utils';
import CopyToClipboard from 'react-copy-to-clipboard';

const SocialShare = (props) => {
    const { compCss = {}, btnStyles, val, btnTitle, positionDropdown, setIsOpen } = props;
    const [shareModal, setShareModal] = useState(false);
    const { setAlertData } = useContext(UserContext);
    const { profileData, officePage } = useContext(UserProfileContext) || {};
    const valueCurrent = useMemo(
        () => (props?.addRef ? `${val}${profileData?.username ? `?ref=${profileData?.username}` : ''}` : val),
        [profileData?.username, props?.addRef, val]
    );

    const transl = useWidgetTranslates('share');
    return (
        <>
            {shareModal && positionDropdown === 'left' && (
                <div
                    className={css.modalShareBodyBackground}
                    onClick={() => {
                        setShareModal(false);
                        setIsOpen && setIsOpen(false);
                    }}
                ></div>
            )}
            <div
                onClick={() => {
                    setShareModal(true);
                    setIsOpen && setIsOpen(true);
                }}
                className={classnames(css.btnShare, compCss.button)}
            >
                <div className={classnames(btnStyles, compCss.iconWrap, uikit.flexColumn, uikit.justifyContentCenter)}>
                    {svgSprite(officePage ? 'share-gt' : 'share', {
                        width: '22px',
                        height: '22px',
                        fill: shareModal ? 'var(--blueColor)' : 'var(--greyExtraDarkColor)',
                        className: compCss.icon
                    })}
                </div>
                {btnTitle && <div className={classnames(css.btnShareTitle, compCss.title)}>{btnTitle}</div>}
                {shareModal && (
                    <div
                        className={classnames(
                            css.modalShareBody,
                            compCss.modalShareBody,
                            positionDropdown === 'left' ? css.modalShareBodyLeft : css.modalShareBodyBottom
                        )}
                        onMouseLeave={() => {
                            setShareModal(false);
                            setIsOpen && setIsOpen(false);
                        }}
                    >
                        <div className={css.modalShare}>
                            <div
                                style={{ position: 'absolute' }}
                                className={classnames(
                                    positionDropdown === 'left' ? css.dropdownWhiteArrowLeft : css.dropdownWhiteArrowBottom
                                )}
                            >
                                {svgSprite('arrow-dropdown-right', {
                                    width: '14px',
                                    height: '36px',
                                    fill: 'var(--whiteColor)'
                                })}
                            </div>
                            {props?.addRef && profileData?.username ? (
                                <div
                                    className={classnames(
                                        css.modalShareItemWrapper,
                                        css.modalShareItemWrapperFirst,
                                        css.modalShareItemHover
                                    )}
                                >
                                    <CopyToClipboard
                                        text={`${val}${profileData?.username ? `?ref=${profileData?.username}` : ''}`}
                                        onCopy={() =>
                                            setAlertData({
                                                type: 'success',
                                                cont: t(
                                                    'FormCopy-CopyReferalLink-success',
                                                    'Скопировано в буфер обмена',
                                                    'widget',
                                                    transl,
                                                    'share'
                                                )
                                            })
                                        }
                                    >
                                        <div className={css.modalShareItem}>
                                            <div className={css.modalShareItemIcon}>
                                                {svgSprite('ref-social', {
                                                    width: '20',
                                                    height: '20',
                                                    fill: 'var(--darkColor)'
                                                })}
                                            </div>
                                            <div>{t('storeShareRefLink', 'Реф. ссылка на товар', 'widget', transl, 'share')}</div>
                                        </div>
                                    </CopyToClipboard>
                                </div>
                            ) : null}
                            <div
                                className={classnames(
                                    css.modalShareItemWrapper,
                                    css.modalShareItemWrapperFirst,
                                    css.modalShareItemHover
                                )}
                            >
                                <FacebookShareButton url={valueCurrent}>
                                    <div className={css.modalShareItem}>
                                        <div className={css.modalShareItemIcon}>
                                            <FacebookIcon
                                                size={40}
                                                iconFillColor={'rgba(72, 103, 170, 1)'}
                                                bgStyle={{
                                                    fill: 'transparent'
                                                }}
                                            />
                                        </div>
                                        <div>Facebook</div>
                                    </div>
                                </FacebookShareButton>
                            </div>
                            <div className={classnames(css.modalShareItemWrapper, css.modalShareItemHover)}>
                                <TwitterShareButton url={valueCurrent}>
                                    <div className={css.modalShareItem}>
                                        <div className={css.modalShareItemIcon}>
                                            <TwitterIcon
                                                size={40}
                                                round={true}
                                                borderRadius={40}
                                                iconFillColor={'rgba(29, 161, 242, 1)'}
                                                bgStyle={{
                                                    fill: 'transparent'
                                                }}
                                            />
                                        </div>
                                        <div>Twitter</div>
                                    </div>
                                </TwitterShareButton>
                            </div>
                            <div className={classnames(css.modalShareItemWrapper, css.modalShareItemHover)}>
                                <WhatsappShareButton url={valueCurrent}>
                                    <div className={css.modalShareItem}>
                                        <div className={css.modalShareItemIcon}>
                                            <WhatsappIcon
                                                size={30}
                                                iconFillColor={'rgba(39, 210, 70, 1)'}
                                                bgStyle={{
                                                    fill: 'transparent'
                                                }}
                                            />
                                        </div>
                                        <div>WhatsApp</div>
                                    </div>
                                </WhatsappShareButton>
                            </div>
                            <div className={classnames(css.modalShareItemWrapper, css.modalShareItemHover)}>
                                <TelegramShareButton url={valueCurrent}>
                                    <div className={css.modalShareItem}>
                                        <div className={css.modalShareItemIcon}>
                                            <TelegramIcon
                                                size={30}
                                                iconFillColor={'rgba(37, 163, 225, 1)'}
                                                bgStyle={{
                                                    fill: 'transparent'
                                                }}
                                            />
                                        </div>
                                        <div>Telegram</div>
                                    </div>
                                </TelegramShareButton>
                            </div>
                            <div
                                className={classnames(
                                    css.modalShareItemWrapper,
                                    css.modalShareItemWrapperLast,
                                    css.modalShareItemHover
                                )}
                            >
                                <ViberShareButton url={valueCurrent}>
                                    <div className={css.modalShareItem}>
                                        <div className={css.modalShareItemIcon}>
                                            <ViberIcon
                                                size={30}
                                                iconFillColor={'rgba(102, 92, 172, 1)'}
                                                bgStyle={{
                                                    fill: 'transparent'
                                                }}
                                            />
                                        </div>
                                        <div>Viber</div>
                                    </div>
                                </ViberShareButton>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
SocialShare.propTypes = {
    btnStyles: PropTypes.object,
    styles: PropTypes.object,
    val: PropTypes.string,
    btnTitle: PropTypes.node,
    positionDropdown: PropTypes.oneOf(['left'])
};
export default SocialShare;
